import React, { useEffect, useState } from 'react';
import {
  connectorMinimumSupportedBannerMessage,
  isConnectorBelowMinimumSupported,
} from '../utils/connectorCapability';
import { openManualDownloadUrl, resolveManualDownloadUrl } from '../utils/updaterUi';

const GOLD = '#C9A84C';

/**
 * Persistent, non-dismissable banner when the installed Connector is below
 * MIN_SUPPORTED_CONNECTOR. Separate from the optional “newer version available” banner.
 */
export default function ConnectorMinimumVersionBanner() {
  const [downloadUrl, setDownloadUrl] = useState(null);
  const isTauri = typeof window !== 'undefined'
    && ('__TAURI__' in window || '__MAESTRO_CONNECTOR__' in window);

  useEffect(() => {
    if (!isTauri) return;
    let cancelled = false;
    (async () => {
      const url = await resolveManualDownloadUrl(null);
      if (!cancelled) setDownloadUrl(url);
    })();
    return () => { cancelled = true; };
  }, [isTauri]);

  if (!isTauri || !isConnectorBelowMinimumSupported() || !downloadUrl) return null;

  const message = connectorMinimumSupportedBannerMessage();

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #dc262618, #dc262610)',
        borderBottom: '1px solid #dc262640',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        position: 'relative',
        zIndex: 61,
      }}
      role="alert"
    >
      <span style={{ fontSize: 13, color: 'var(--text-primary)', flex: 1, lineHeight: 1.45 }}>
        {message}
      </span>
      <button
        type="button"
        onClick={() => openManualDownloadUrl(downloadUrl)}
        style={{
          flexShrink: 0,
          padding: '6px 14px',
          borderRadius: 8,
          border: 'none',
          background: GOLD,
          color: '#1a1a2e',
          fontSize: 12,
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        Download update
      </button>
    </div>
  );
}
